import React from 'react';
import Table from 'components/common/Table';
import moment from 'moment';

const guessedTz = moment.tz.guess();
const emailMetrics1 = [
  "email_delivered",
  "email_open",
  "email_click",
  "email_sent",
  "email_failed",
];

const emailMetrics2 = [
  "email_dropped",
  "email_spamreport",
  "email_blocks",
];

const toPercent = (num1, num2) => {
  return (Number(num1) / Number(num2)).toLocaleString(undefined, {
    style: 'percent', minimumFractionDigits: 2,
  }) || '0.00%';
};

const calculatedEmailMetrics = (data) => {
  const { email_open, email_click, email_delivered } = data;

  return [
    ["open", toPercent(email_open, email_delivered)],
    ["click", toPercent(email_click, email_delivered)],
    ["COO", toPercent(email_click, email_open)],
  ];
};

const textMetrics = [
  "sms_delivered",
  "sms_undelivered",
  "sms_sent",
  "sms_failed",
];

const hasEmail = (data) => {
  return data.has_email === 'true';
};

const hasText = (data) => {
  return data.has_text === 'true';
};

const computeColumns = () => {
  return [
    {
      Header: 'Metrics',
      accessor: (data) => (
        <div className="flex-1">
          <div className="">
            <div className="">{data.batch_name}</div>
            <div className="flex mt-2">
              {!hasEmail(data) && !hasText(data) && (
                <div className="flex pr-4">
                  <p className="pr-1 font-semibold">Push Campaign Only</p>
                </div>
              )}
              {hasEmail(data) && emailMetrics1.map((type) => (
                <div className="flex pr-4">
                  <p className="pr-1 font-semibold">{`${type}:`}</p>
                  <p>
                    {data[type]}
                  </p>
                </div>
              ))}
            </div>
            <div className="flex mt-2">
              {hasEmail(data) && emailMetrics2.map((type) => (
                <div className="flex pr-4">
                  <p className="pr-1 font-semibold">{`${type}:`}</p>
                  <p>
                    {data[type]}
                  </p>
                </div>
              ))}
            </div>
            <div className="flex mt-2">
              {hasEmail(data) && calculatedEmailMetrics(data).map((type) => (
                <div className="flex pr-4">
                  <p className="pr-1 font-semibold">{`${type[0]}:`}</p>
                  <p>
                    {type[1]}
                  </p>
                </div>
              ))}
            </div>
            <div className="flex mt-2">
              {hasText(data) && textMetrics.map((type) => (
                <div className="flex pr-4">
                  <p className="pr-1 font-semibold">{`${type}:`}</p>
                  <p>
                    {data[type]}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      ),
    },
    {
      Header: "created at",
      accessor: (data) => {
        const { created_at } = data;
        return (
          <div>{moment.tz(created_at, "UTC").tz(guessedTz).format("MM-DD-YYYY hh:mm:ss zz")}</div>
        );
      },
    },
  ];
};

export default ({ metrics }) => {

  return (
    <Table
      data={metrics}
      id="Marketing Campaigns Metrics"
      columns={computeColumns()}
    />
  );
};